import React from 'react';
import DialogModal from '../../../components/DialogModal';
import { PromotionDialogProps } from '../types/ProvisionalPromotionTypes';
import {
  DialogFormColumn,
  DialogFormRow,
  StyledButton,
  StyledDropdown,
  StyledMultiSelect
} from '../styled';
import CustomMenuItem from '../../../components/CustomMenuItem/CustomMenuItem';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

const PromotionDialog: React.FC<PromotionDialogProps> = ({
  open,
  submitting,
  formValues,
  formErrors,
  gradeOptions,
  divisionOptions,
  fixedConcessions,
  onClose,
  onSubmit,
  onFieldChange
}) => {
  const concessionsOptions = fixedConcessions.map((concession) => ({
    value: concession.description,
    label: concession.description
  }));

  const { user } = useSelector((state: RootState) => state.profile);

  const onConcessionsChange = (value: string[]) =>
    onFieldChange('applicableConcessions', value);
  const onChangeHandler =
    (field: 'academicYear' | 'grade' | 'division') => (e: any) =>
      onFieldChange(field, e.target.value as string);

  const isSubmitDisabled = !formValues.grade || !formValues.division;

  return (
    <DialogModal
      open={open}
      onClose={onClose}
      title='Provisionally Promote To'
      maxWidth='sm'
      actions={
        <StyledButton
          variant='contained'
          onClick={onSubmit}
          disabled={isSubmitDisabled}
          loading={submitting}
        >
          Submit
        </StyledButton>
      }
    >
      <DialogFormColumn>
        <DialogFormRow>
          <StyledDropdown
            label='Academic Year'
            name='academicYear'
            value={formValues.academicYear || ''}
            onChange={onChangeHandler('academicYear')}
            options={[{ value: '2026-2027', label: '2026-2027' }]}
            hasTopLabel
            placeholder='Select Academic Year'
            helperText={formErrors.academicYear}
            sx={{ flex: 1 }}
          >
            <CustomMenuItem value=''>Select Academic Year</CustomMenuItem>
            {[{ value: '2026-2027', label: '2026-2027' }].map(
              (academicYear) => (
                <CustomMenuItem
                  key={academicYear.value}
                  value={academicYear.value}
                >
                  {academicYear.label}
                </CustomMenuItem>
              )
            )}
          </StyledDropdown>
        </DialogFormRow>
        <DialogFormRow>
          <StyledDropdown
            label='Grade'
            name='grade'
            value={formValues.grade || ''}
            onChange={onChangeHandler('grade')}
            options={gradeOptions}
            hasTopLabel
            placeholder='Select Grade'
            helperText={formErrors.grade}
            sx={{ width: 568 }}
          />
        </DialogFormRow>
        <DialogFormRow>
          <StyledDropdown
            label='Division'
            name='division'
            value={formValues.division || ''}
            onChange={onChangeHandler('division')}
            options={divisionOptions}
            hasTopLabel
            placeholder='Select Division'
            helperText={formErrors.division}
            disabled={!formValues.grade}
            sx={{ width: 568 }}
          />
        </DialogFormRow>
        <DialogFormRow>
          <StyledMultiSelect
            label='Applicable Concessions'
            placeholder='Select Concessions'
            required={false}
            options={user?.school === 'BPIS' ? [] : concessionsOptions}
            selected={formValues.applicableConcessions}
            onChange={onConcessionsChange}
            disabled={submitting}
            hasTopLabel
            formControlMargin='none'
            sx={{ width: 568 }}
          />
        </DialogFormRow>
      </DialogFormColumn>
    </DialogModal>
  );
};

export default PromotionDialog;
